import { gettingStarted } from './privateCloudBusinessEditionFieldConfigVME';
export const pagesConfig = [...gettingStarted()];
